import {
  CheckFeatureAccessHeader,
  useQueryWithAccessCheckLog,
} from "@src/auth/permissions/usePreRequestFeatureAccessCheck";
import FetchClients, { ClientPaths, ClientOutput } from "../client";

export type SummaryUtilitiesReportQuery =
  ClientPaths["utilities"]["/reports/summary_utilities"]["get"]["parameters"]["query"];
export type SummaryUtilitiesReport =
  ClientOutput["utilities"]["SummaryUtilityUsageReport"];
export type DatePeriod = ClientOutput["utilities"]["DatePeriod"];

const reports = {
  useSummaryUtilities,
} as const;

export default reports;

const SUMMARY_QUERY_KEY = "summary-utilities-report";

// endpoint requires {feature: "Utilities", access: "read"}
async function getSummaryUtilities(
  query: SummaryUtilitiesReportQuery,
  checkFeatureAccessHeader: CheckFeatureAccessHeader
) {
  const { data, error } = await FetchClients.utilities.GET(
    "/reports/summary_utilities",
    {
      params: {
        query,
      },
      headers: checkFeatureAccessHeader,
    }
  );
  if (data) return data;
  throw new Error(error);
}

function useSummaryUtilities(query: SummaryUtilitiesReportQuery) {
  return useQueryWithAccessCheckLog(
    ["Utilities", "read"],
    (checkFeatureAccessHeader) =>
      getSummaryUtilities(query, checkFeatureAccessHeader),
    {
      queryKey: [SUMMARY_QUERY_KEY, query],
    }
  );
}
